import { Network, SlateFunctions } from "../../.."
import store from "../../../../store"
import { axiosWrapper } from "../../../axios_old"
import { formatDate } from "../../../formating"
import { normalizeString } from "../../../functions"

const AdminEmail = async (args) => {
  const { user, data, action, setNotification, history, original } = args
  try {
    let newData = {}

    if (action === "GET_ALL") {
      const {
        data: { data: emailData }
      } = await axiosWrapper("GET", "emailTemplate", null, null, user.token)
      newData = emailData.map((template) => {
        const { modifiedTs } = template
        return {
          ...template,
          tableValues: {
            lastModified: formatDate({
              data: modifiedTs,
              actions: ["display+time"]
            })
          }
        }
      })
    } else if (action === "GET_ONE") {
      const { data: emailData } = await axiosWrapper(
        "GET",
        `emailTemplate/${data.id}`,
        null,
        null,
        user.token
      )

      newData = emailData
      newData.htmlBodyText = newData.htmlBody

      if (newData?.slateParams?.params) {
        newData.htmlBody = newData.slateParams.params
      } else {
        newData.htmlBody = [
          { type: "paragraph", children: [{ text: "Hello {firstName}," }] }
        ]
      }
    } else if (action === "CREATE") {
      const payload = { ...data }
      await axiosWrapper("POST", `emailTemplate`, payload, null, user.token)
      await store.setNotification("notification", true, {
        msg: "Successfully added email template: " + data.name,
        severity: "success"
      })
    } else if (action === "UPDATE") {
      const payload = { ...data }
      delete payload.id
      await axiosWrapper(
        original.links.update?.method,
        original.links.update?.url,
        payload,
        null,
        user.token,
        null,
        { disablePrefix: true }
      )
      await store.setNotification("notification", true, {
        msg: "Successfully updated email template: " + data.name,
        severity: "success"
      })
    } else if (action === "DELETE") {
      const { link, name } = data
      await axiosWrapper(
        link.method,
        link.url,
        null,
        null,
        user.token,
        null,
        { disablePrefix: true }
      )
      await store.setNotification("notification", true, {
        msg: "Successfully deleted email template: " + name,
        severity: "success"
      })
    } else if (action === "GET_MARKETING_VALUES") {
      const { data: marketingVariablesData } = await axiosWrapper(
        "GET",
        `marketing/email/parameters`,
        null,
        null,
        user.token
      )
      newData = marketingVariablesData
    } else if (action === "SEND_TEST") {
      let name = "your account"
      const templateName = data.name
      delete data.name
      if (data.firstName) {
        name = `${data.firstName} ${data.lastName}`
        delete data.firstName
        delete data.lastName
      }

      await axiosWrapper(
        "POST",
        `emailTemplate/${templateName}/preview`,
        data,
        null,
        user.token
      )
      await store.setNotification("notification", true, {
        msg: `Successfully sent email test: ${templateName} to ${name}`,
        severity: "success"
      })
    } else if (action === "SEND_TEST_HTML") {
      let name = "your account"
      const templateName = data.name
      delete data.name
      if (data.firstName) {
        name = `${data.firstName} ${data.lastName}`
        delete data.firstName
        delete data.lastName
      }

      await axiosWrapper(
        "POST",
        `emailTemplate/preview`,
        data,
        null,
        user.token
      )
      await store.setNotification("notification", true, {
        msg: `Successfully sent email test: ${templateName} to ${name}`,
        severity: "success"
      })
    }

    history && history(-1)
    return newData
  } catch (err) {
    console.error(err)
    await setNotification("notification", true, {
      msg: err.response?.data.message,
      severity: "error"
    })
  }
}

export default AdminEmail
